export default "__VITE_ASSET__55dda406__"